// removed by extract-text-webpack-plugin
module.exports = {"imagePanelContainer":"imagePanelContainer__3ewGQ","imagePanelHeader":"imagePanelHeader__b0lYk","imagePanelSection":"imagePanelSection__1onxu"};


//////////////////
// WEBPACK FOOTER
// ./components/imagePanel/style.css
// module id = JT+J
// module chunks = 323 344